<template>
    <div>
      <table class="uk-table uk-table-hover uk-table-divider ctable" :id="name">
        <thead>
        <tr>
          <th v-for="h in heads">{{ h }}</th>
          <th v-if="links !== null">
            Tools
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(d, i) in data" :key="i" :data-id="d.id">
          <td v-for="o in dataObjects">
            {{ d[o] }}

            <span v-html="dataIcons[o]">{! (typeof dataIcons[o] !== 'undefined' ? dataIcons[o] : '') !}</span>
          </td>
          <td v-if="links !== null">
            <div class="uk-button-group uk-text-center">
              <router-link v-if="(typeof links.show !== 'undefined') ? links.show : false" :to="`${linkBase}/${d.id}`"
                class="uk-button uk-button-small uk-button-primary">
                <i class="fas fa-eye"></i>
                Show
              </router-link>
              <a v-if="(typeof links.delete !== 'undefined') ? links.delete : false" @click="linkDelete(d.id)"
                class="uk-button uk-button-small uk-button-danger">
                <i class="fas fa-trash"></i>
                Delete
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
  import $ from 'jquery';

  export default {
    name: "ctable",
    props: {
      name: '',
      heads: null,
      data: null,
      dataObjects: null,
      dataIcons: null,
      linkBase: null,
      links: null
    },
    methods: {
      linkDelete(id) {
        const self = this;

        self.$request().delete(`/${self.linkBase}` + `/${id}`)
          .then(r => {
            const tr = $('table#'+self.name+'>tbody>tr[data-id="'+id+'"]');
            tr.remove();
            self.$uikit().notification({
              message: 'Deletion successfully completed.',
              status: 'success',
              pos: 'top-right',
              timeout: 5000
            });
          })
          .catch(e => {
            self.$uikit().notification({
              message: 'Something went wrong! Please try again later.',
              status: 'danger',
              pos: 'top-right',
              timeout: 5000
            });
          });
      }
    }
  }
</script>

<style scoped>
  .ctable>tbody>tr>td{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ctable.vue